import { InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { CreditAccount } from './CreditAccount'

@InputType()
export class GetCreditBalanceArgs extends ActionArgs {
  /**
   * Target owner to read — a `User._id` (User scope) or `Tenant._id` (Tenant scope). NOT a GraphQL
   * input field: both the `getCreditBalance` and the deprecated `creditBalance` queries supply it
   * inside `filter` (`filter.ownerId`, spread flat into these args as `{ ...filter, user }`), where
   * `GetCreditBalance` names and guards it before the read. The caller must hold `canManageAiBilling`.
   */
  ownerId?: string
}

export interface IGetCreditBalance extends IAction<CreditAccount | null, GetCreditBalanceArgs> {}
